import { supabase } from '../../../infra_/supabase/supabaseClient.js'; 


export async function vistaListarVentasXMetodo({ fechaInicio, fechaFin } = {}) {
  let query = supabase
    .from("vista_ventas_metodo")
    .select("*")
    .order("fecha_factura", { ascending: true })
    .limit(31);

  // Filtro opcional por rango de fechas
  if (fechaInicio && fechaFin) {
    query = query
      .gte("fecha_factura", fechaInicio)
      .lte("fecha_factura", fechaFin);
      
  } 

  const { data, error } = await query;
  console.log("[vistaVentasXMetodo.repository] Datos obtenidos:", data);
  if (error) {
    console.error("[vistaVentasXMetodo.repository] Error:", error.message);
    throw new Error("No se pudo obtener el reporte de ventas por método");
  }

  return data;

}
